import CrudSection from "../components/CrudSection";
import PlaceholderSection from "../components/PlaceholderSection";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Dispositivos — secciones con datos de ejemplo que aún no pasan al API (las demás viven en ../screens, CC-CONSOLE #1593).
// Inventario de hardware de control de acceso: controladoras, lectores,
// terminales biométricas, plumas y gateways. Front-end scaffold (mock data).
// ===========================================================================

// --- Lectores y terminales -------------------------------------------------
interface Lector extends Record<string, unknown> {
  id: string; nombre: string; tecnologia: string; puerta: string; estado: string;
}
const lectorColumns: CrudColumn<Lector>[] = [
  { key: "nombre", label: "Lector / terminal" },
  { key: "tecnologia", label: "Tecnología" },
  { key: "puerta", label: "Puerta / acceso" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const lectorFields: CrudField[] = [
  { key: "nombre", label: "Nombre", required: true, placeholder: "Lector QR-04" },
  { key: "tecnologia", label: "Tecnología", type: "select", defaultValue: "QR", options: [
    { value: "QR", label: "QR" },
    { value: "RFID", label: "RFID" },
    { value: "Huella", label: "Huella" },
    { value: "Facial", label: "Facial" },
    { value: "PIN", label: "PIN" },
  ] },
  { key: "puerta", label: "Puerta / acceso", required: true, placeholder: "Acceso peatonal" },
  { key: "estado", label: "Estado", type: "select", defaultValue: "En línea", options: [
    { value: "En línea", label: "En línea" }, { value: "Offline", label: "Offline" },
  ] },
];
const lectorSeed: Lector[] = [
  { id: "l1", nombre: "Lector RFID-02", tecnologia: "RFID", puerta: "Torniquete A", estado: "En línea" },
  { id: "l2", nombre: "Lector QR-04", tecnologia: "QR", puerta: "Acceso peatonal", estado: "Offline" },
  { id: "l3", nombre: "Terminal biométrica B-03", tecnologia: "Huella", puerta: "Torre B", estado: "En línea" },
  { id: "l4", nombre: "Terminal facial F-01", tecnologia: "Facial", puerta: "Lobby", estado: "En línea" },
];
export const LectoresSection = () => (
  <CrudSection<Lector> title="Lectores y terminales" subtitle="Lectores QR/RFID y terminales biométricas"
    icon="ri-fingerprint-line" columns={lectorColumns} fields={lectorFields} seed={lectorSeed} searchKey="nombre" />
);

// --- Mantenimiento y firmware ----------------------------------------------
export const MantenimientoSection = () => (
  <PlaceholderSection
    title="Mantenimiento y firmware"
    subtitle="Actualizaciones, diagnósticos y servicio del hardware"
    icon="ri-tools-line"
    bullets={[
      "Programar actualizaciones de firmware por dispositivo o lote",
      "Diagnóstico remoto y reinicio de controladoras y lectores",
      "Alertas de batería baja, sabotaje y pérdida de conexión",
      "Bitácora de mantenimientos preventivos y correctivos",
    ]}
  />
);
